import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import FabricationServices from "./sections/FabricationServices";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <FabricationServices />
      <Footer />
    </div>;
}